const initialState={
    data:null,
    status:"idle",
    error:null,
}

const footerReducer=( state=initialState,action)=>{
    switch(action.type){
        case "SET_FOOTER_DATA":
            return {...state, data:action.payload};
        default:
            return state;
    }

}

export default footerReducer;